<template>
  <div class="btnContent" v-if="hasAuth">
    <el-button
      :type="type"
      :plain="plain"
      :icon="icon"
      v-if="authType === 'btn'"
      :loading="loading"
      >{{ label }}</el-button
    >
    <span v-else>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'authButton',
  props: {
    authType: {
      type: String,
      default: 'btn' // button标签或span标签
    },
    // el-button的按钮的属性，authType为button才有效
    type: {
      type: String,
      default: 'primary'
    },
    // authType为button才有效
    icon: {
      type: String,
      default: ''
    },
    // 用来判断是否有权限
    opt: {
      type: String,
      default: 'add' // 页面需唯一
    },
    // 按钮文本
    label: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    hasAuth () {
      let flag = false
      if (this.$parent.buttonOpt && this.$parent.buttonOpt.includes(this.opt)) {
        flag = true
      }
      if (this.$route.meta.handler && this.$route.meta.handler.length > 0) {
        flag = this.$route.meta.handler.some(item => {
          if (!this.$parent.buttonOpt) {
            this.$parent.buttonOpt = []
          }
          this.$parent.buttonOpt.push(this.opt)
          return item.opt === this.opt
        })
      }
      return flag
    }
  },
  mounted () {
    // if (this.$parent.buttonOpt && this.$parent.buttonOpt.includes(this.opt)) {
    //   this.hasAuth = true
    // }
    // console.log(this.$parent.buttonOpt)
    // if (this.$route.meta.handler && this.$route.meta.handler.length > 0) {
    //   this.hasAuth = this.$route.meta.handler.some(item => {
    //     if (!this.$parent.buttonOpt) {
    //       this.$parent.buttonOpt = []
    //     }
    //     this.$parent.buttonOpt.push(this.opt)
    //     return item.opt === this.opt
    //   })
    // }
  }
}
</script>
<style lang="less" scoped>
.btnContent {
  display: inline-block;
  span {
    color: var(--main-color);
    cursor: pointer;
  }
}
</style>
